export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-2">Legal</p>
      <h1 className="font-display font-extrabold uppercase text-3xl md:text-4xl text-zinc-950 tracking-tight mb-6">Privacy Policy</h1>
      <p className="text-zinc-500 text-sm mb-10">Last updated: 2026</p>

      <div className="prose prose-zinc max-w-none space-y-8 text-zinc-700 leading-relaxed">
        <section>
          <h2 className="font-display font-bold text-xl text-zinc-950 mb-3">What we collect</h2>
          <p>
            When you create an account, vote on a scenario, submit an incident report, donate, or sign up for
            updates on BBAP, we collect your email address (and name, if provided). This applies to every way
            you participate on the platform — it isn't limited to account registration.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl text-zinc-950 mb-3">How we use it</h2>
          <p>
            We use your email address to send you updates about BBAP — new features, advocacy progress, and
            ways to get involved. We may also use it to respond to you directly if you've submitted an incident
            report or reached out to us. We do not sell your email address to third parties.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl text-zinc-950 mb-3">Your choices</h2>
          <p>
            You can unsubscribe from BBAP updates at any time using the unsubscribe link included in any email
            we send you. Unsubscribing stops marketing emails but does not delete your account or submitted
            content.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl text-zinc-950 mb-3">Incident reports & scenarios</h2>
          <p>
            Content you submit (scenarios, incident reports, evidence files) is stored securely and used for
            pattern-tracking, community voting, and advocacy purposes as described in our mission. We take
            care to keep documentation focused on behavior and patterns, not to publicly expose personal
            information about the people involved.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl text-zinc-950 mb-3">Contact</h2>
          <p>
            Questions about this policy or your data? Reach out through the contact details on our donation or
            about pages.
          </p>
        </section>
      </div>
    </div>
  );
}
